<template>
  <div id="close-button" class="close-button" :style="iconSetter">
    <svg :width="svgWidthHeight" :height="svgWidthHeight" >
      <circle :cx="circleWidthHeight" :cy="circleWidthHeight" :r="radius" :style="dashArray" ref="circle"/>
    </svg>
    <div class="icon"></div>
  </div>
</template>

<script>
export default {
  name: 'CloseButton',
  props: {
    radius: Number,
    strokeWidth: Number
  },
  computed: {
    dashArray: function () {
      let diameter = (this.radius * 2) * Math.PI
      return { '--dash-array': diameter, '--stroke': this.strokeWidth }
    },
    svgWidthHeight: function () {
      return (this.radius * 2) + this.strokeWidth
    },
    circleWidthHeight: function () {
      return this.radius + (this.strokeWidth / 2)
    },
    iconSetter: function () {
      let strokeWidth = (this.strokeWidth * 0.1) + 'rem'
      let size = ((this.radius * 1.3333) * 0.1) + 'rem'
      let left = (this.radius * 0.1) + 'rem'
      let top = (this.radius * 0.04166) + 'rem'
      let center = (((this.radius * 1.3333) / 2 - this.strokeWidth) * 0.1) + 'rem'
      return { '--stroke-width': strokeWidth, '--size': size, '--left': left, '--top': top, '--center': center }
    }
  }
}
</script>

<style scoped>
.close-button {
  position: absolute;
  --stroke-width: 0.4rem;
  --size: 3.2rem;
  --top: 1rem;
  --left: 2.4rem;
  --center: 1rem
}
.icon {
  position: absolute;
  top: 3px;
  left: 16.5px;
  transform: rotate(45deg);
}
.icon::after {
  content: "";
  display: block;
  position: absolute;
  top: 9px;
  left: 0;
  width: 20px;
  height: 2px;
  background: var(--black);
  border-radius: 4px;
  animation: icon 0.8s 1 ease-out;
  animation-fill-mode: backwards;
}
.icon::before {
  content: "";
  display: block;
  position: absolute;
  top: 9px;
  left: 0;
  width: 20px;
  height: 2px;
  background: var(--black);
  border-radius: 4px;
  animation: icon2 0.8s 1 ease-out;
  animation-fill-mode: forwards;
}
svg {
  transform: rotate(-90deg);
}

circle {
  --dash-array: 377;
  --stroke: 4px;
  fill: transparent;
  stroke: var(--black);
  stroke-width: var(--stroke);
  animation: circle 1s 1;
}

@keyframes circle {
  0% { stroke-dasharray: 0 var(--dash-array); }
  100%,to { stroke-dasharray: var(--dash-array) var(--dash-array); }
}

@keyframes icon {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(180deg);
  }
}
@keyframes icon2 {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(270deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Atoms/CloseButton.vue